export default "__VITE_ASSET__qfiYgqLK__ 100w";